var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.813 25.2C16.9534 25.4432 17.1554 25.6451 17.3986 25.7855C17.6418 25.926 17.9177 25.9999 18.1986 25.9999C18.4794 25.9999 18.7553 25.926 18.9986 25.7855C19.2418 25.6451 19.4438 25.4432 19.5842 25.2",
    stroke: "#333333",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7312 10.2511C19.0092 10.0078 18.2396 9.93984 17.4861 10.0529C16.7326 10.166 16.0169 10.4567 15.3981 10.9012C14.7793 11.3457 14.2751 11.9311 13.9274 12.6091C13.5797 13.287 13.3983 14.038 13.3983 14.7999C13.3983 18.3991 12.2695 19.5647 11.2063 20.6615C11.102 20.7762 11.0332 20.9187 11.0084 21.0718C10.9835 21.2248 11.0037 21.3817 11.0664 21.5235C11.1291 21.6653 11.2317 21.7858 11.3616 21.8704C11.4916 21.955 11.6433 22 11.7983 21.9999H24.5984C24.7534 22 24.9051 21.955 25.0351 21.8704C25.165 21.7858 25.2676 21.6653 25.3303 21.5235C25.393 21.3817 25.4132 21.2248 25.3884 21.0718C25.3635 20.9187 25.2947 20.7762 25.1904 20.6615C25.0258 20.492 24.8696 20.3144 24.7224 20.1295",
    stroke: "#333333",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9986 17.1999C24.3241 17.1999 25.3987 16.1254 25.3987 14.7999C25.3987 13.4744 24.3241 12.3999 22.9986 12.3999C21.6732 12.3999 20.5986 13.4744 20.5986 14.7999C20.5986 16.1254 21.6732 17.1999 22.9986 17.1999Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsFull);
export default __webpack_public_path__ + "static/media/notifications-full.be623d5c5bf5a760cd19932d95d49967.svg";
export { ForwardRef as ReactComponent };